export default "__VITE_ASSET__3796b243__"